export default "__VITE_ASSET__BHLtyech__"